import BasicPropertyInfo from './BasicPropertyInfo';

export default class BuildingRiskDataCommercial extends BasicPropertyInfo {
	public buildingDescription: string | null = null;
	public parkingType: string | null = null;

	public constructor() {
		super();
	}
};